import { WorksheetSaveSheet, WorksheetSheet } from '../models/worksheet-app.model';

/** Adapt the server's save-shape sheets (Workbooks Import, the report workbook preview) → renderable WorksheetSheet[]. */
export function toDraftSheets(sheets: ReadonlyArray<WorksheetSaveSheet>): ReadonlyArray<WorksheetSheet> {
	return sheets.map(
		(s: WorksheetSaveSheet): WorksheetSheet => ({
			name: s.name,
			data: s.tableData,
			tableStructure: s.tableStructure.initSettings,
			cellStructure: s.tableStructure.fscCellSettings,
		})
	);
}
